import {ChangeDetectorRef, Component, EventEmitter, Input, NgZone, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import {ParksHandlerService} from '../../../api-handlers/parks-handler.service';
import {VehiclesHandlerService} from '../../../api-handlers/vehicles-handler.service';
import {AuthService} from '../../../auth-n-routing/auth-service.service';
import {Park} from '../../../models/park';
import {Vehicle} from '../../../models/vehicle';
import {SnackBarHandlerService} from '../../../commons/snack-bar-handler.service';
import {RefillsHandlerService} from '../../../api-handlers/refills-handler.service';
import {User} from '../../../models/user';
import {DateHandlerService} from '../../../commons/date-handler.service';
import {TravelsHandlerService} from '../../../api-handlers/travels-handler.service';
import {AssignUserToCarComponent} from '../../../dialogs/assign-user-to-car/assign-user-to-car.component';
import * as d3Scale from 'd3-scale';
import {ExportXLSPDF} from '../../../commons/export-xls-pdf.service';
import {FermiTecniciComponent} from '../../../dialogs/fermi-tecnici/fermi-tecnici.component';
import {CreateFermoTecnicoComponent} from '../../../dialogs/create-fermo-tecnico/create-fermo-tecnico.component';
import {saveAs as importedSaveAs} from 'file-saver';

@Component({
	selector: 'app-admin',
	templateUrl: './admin.component.html',
	styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {
	@ViewChild(AssignUserToCarComponent, { static: false }) assignUserToCarDialog: AssignUserToCarComponent;
	@ViewChild('barParent', { static: false }) barParent;
	@ViewChild(FermiTecniciComponent, {static: false} ) fermiTecniciDialog: FermiTecniciComponent;
	@ViewChild(CreateFermoTecnicoComponent, {static: false} ) createFermoTecnicoDialog: CreateFermoTecnicoComponent;
	@Output() statusChanged = new EventEmitter();
	parks = [];
	selected_park = null;
	vehicles = {};
	vehicles_available = {};
	view = [100, 0];
	view_is_away = [100, 0];
	view_is_not_used = [100, 0];
	viewTravels = [100, 0];
	view_consumi = [0, 500];
	loadstats = false;
	scheme_rifornimenti = {domain: ['#28a745', '#007bff', '#CF0808']};

	colorScale: any;
	colorScaleTravel: any;
	data: any[] = [];
	data_rifornimenti: any[] = [];
	data_consumi: any[] = [];
	data_is_not_used: any[] = [];
	data_is_away: any[] = [];

	// Veicoli disponibili
	dataVehiclesIcons = [];

	available_vehicles: any[] = [];
	returnedArray: any[];
	itemsPerPage = 25;
	maxSize = 5;
	date_vehicle_available_from: Date;
	date_vehicle_available_to: Date;


	constructor(private parksHandler: ParksHandlerService,
				private changeDetector: ChangeDetectorRef,
				public authService: AuthService,
				public ngZone: NgZone,
				private snackbarService: SnackBarHandlerService,
				private router: Router,
				private refillsHandlerService: RefillsHandlerService,
				private travelsHandlerService: TravelsHandlerService,
				private vehicleHandler: VehiclesHandlerService,
				public dateHandlerService: DateHandlerService,
				public exportService: ExportXLSPDF) {
	}

	ngOnInit() {
		this.authService.authChange.subscribe((u: User) => {
			if (u) {
				this.reloadParks();
			}
		});

		setInterval(() => {
			this.ngZone.run(() => {
				const newVals = [];
				for (let i = 0; i < this.data_is_away.length; i++) {
					const obj = this.data_is_away[i];
					obj.value = this.dateHandlerService.getTimeDiff(new Date(), obj.is_away_until);
					newVals.push(obj);
				}

				this.data_is_away = [...newVals];
				this.changeDetector.detectChanges();
			});

		}, 1000);

		this.date_vehicle_available_from = new Date();
		this.date_vehicle_available_to = new Date();
		this.dataVehiclesIcons = this.vehicleHandler.dataVehiclesIcons;
		this.changeDetector.detectChanges();
	}

	generateColorScale() {
		const values: number[] = this.data_consumi.map(s => s.value);
		return d3Scale.scaleLinear()
		.domain([Math.min(...values), Math.max(...values)])
		.range(['green', 'red']);
	}

	generateColorScaleTravels() {
		const values: number[] = this.data.map(s => s.value);
		console.log(values);
		return d3Scale.scaleLinear()
		.domain([Math.min(...values), Math.max(...values)])
		.range(['red', 'green']);
	}

	customColors = (name) => {
		const value = this.data_consumi.find(s => s.name === name).value;
		return this.colorScale(value);
	}

	customColorsTravels = (name) => {
		const value = this.data.find(s => s.name === name).value;
		return this.colorScaleTravel(value);
	}

	reloadParks() {
		this.parksHandler.getByAdminID().then((res) => {
			this.parks = [];
			res.forEach((park, _index) => {
				park['isOpen'] = false;
				this.parks.push(park);
				if (_index === res.length - 1) {
					park['isOpen'] = true;
				}
			});

			this.changeDetector.detectChanges();
		});
	}

	getVehiclesFromPark(park: Park) {

		this.vehicleHandler.getByParkID(park.id).then((res2) => {
			this.vehicles[park.id] = res2;
			this.vehicleHandler.getByParkIDInDataRangeAvailable(park.id, this.date_vehicle_available_from,
				this.date_vehicle_available_to).then((res) => {
				this.vehicles_available[park.id] = res;
				this.loadstats = true;
				this.updateCharts(park);
			});
		});
	}

	updateCharts(park: Park) {
		this.data = [];
		this.data_rifornimenti = [];
		this.data_consumi = [];
		this.data_is_away = [];
		this.data_is_not_used = [];

		this.available_vehicles = this.vehicles_available[park.id];
		this.returnedArray = this.available_vehicles.slice(0, this.itemsPerPage);

		this.vehicles[park.id].forEach((v) => {
			if (v.is_away) {
				this.data_is_away.push({
					'name': v.plate + ' Riconsegna: ' + this.dateHandlerService.formatDateClassic(v.is_away_until) + ':' +
					this.dateHandlerService.formatTimeClassic(v.is_away_until),
					'value': this.dateHandlerService.getTimeDiff(new Date(), v.is_away_until),
					'is_away_until': v.is_away_until
				});
			}

			if (v.approved !== 0 || v.pending !== 0 || v.refused !== 0) {

				if (!isNaN(v.chilometri_litro) && v.chilometri_litro > 0) {
					this.data_consumi.push({
						'name': v.plate,
						'value': v.chilometri_litro,
					});
				}


				this.data_rifornimenti.push({
					'name': v.plate,
					'series': [
						{
							'name': 'approvati',
							'value': v.approved,
							'total': v.approved_total,
							'color': 'green'
						},
						{
							'name': 'in attesa',
							'value': v.pending,
							'total': v.pending_total,
							'color': 'blue'
						},
						{
							'name': 'rifiutati',
							'value': v.refused,
							'total': v.refused_total,
							'color': 'red'
						}
					]
				});
			}

			if (v.travels !== 0) {
				this.data.push({
					'name': v.plate,
					'value': v.travels
				});
			} else {
				this.data_is_not_used.push({
					'name': v.plate + ', numero viaggi',
					'value': v.travels
				});
			}
		});

		this.data.sort((a, b) => {
			if (a.value < b.value) {
				return 1;
			} else if (a.value > b.value) {
				return -1;
			} else {
				return 0;
			}
		});

		// console.log(this.data_is_not_used);

		this.colorScale = this.generateColorScale();
		this.colorScaleTravel = this.generateColorScaleTravels();
		this.view = [this.barParent.nativeElement.offsetWidth, 100 + (25 * this.data_rifornimenti.length)];
		this.viewTravels = [this.barParent.nativeElement.offsetWidth, 100 + (25 * this.data.length)];
		this.view_is_away = [this.barParent.nativeElement.offsetWidth, 120 * ((this.data_is_away.length / 3) + 1)];
		this.view_is_not_used = [this.barParent.nativeElement.offsetWidth, 120 * ((this.data_is_not_used.length / 3) + 1)];
		this.view_consumi = [this.barParent.nativeElement.offsetWidth, 500 ];
	}

	openChanged(park: Park) {
		/*if (!this.vehicles[park.id] || this.vehicles[park.id].length === 0) {*/
		if (park['isOpen']) {
			this.getVehiclesFromPark(park);
			this.selected_park = park;
		} else {
			this.loadstats = false;
			this.selected_park = null;
		}
		/*}*/
	}

	showRefused(vehicle: Vehicle) {
		if (vehicle['refused'] !== 0) {
			this.refillsHandlerService.refills_list_props.filter_column = 'refills_expanded.vhc_plate';
			this.refillsHandlerService.refills_list_props.filter_value = vehicle.plate.toString();
			this.refillsHandlerService.refills_list_props.status_attivo = 2;
			this.refillsHandlerService.changeFilterName('Targa');
			this.refillsHandlerService.reloadRefillsListAndCount();
			this.router.navigate(['./dashboard/refills']);
		}
	}

	fermiTecnici(vehicle: Vehicle) {
		console.log(vehicle);
		this.fermiTecniciDialog.showDialog(vehicle);
	}

  getVehicleDocument(vehicle: Vehicle) {
    this.vehicleHandler.downloadTagliando(vehicle.plate).then((blob) => {
      importedSaveAs(blob, 'tagliando_' + vehicle.plate + '.pdf');
    });
  }


  showPending(vehicle: Vehicle) {
		if (vehicle['pending'] !== 0) {
			this.refillsHandlerService.refills_list_props.filter_column = 'refills_expanded.vhc_plate';
			this.refillsHandlerService.refills_list_props.filter_value = vehicle.plate.toString();
			this.refillsHandlerService.refills_list_props.status_attivo = 1;
			this.refillsHandlerService.changeFilterName('Targa');
			this.refillsHandlerService.reloadRefillsListAndCount();
			this.router.navigate(['./dashboard/refills']);
		}
	}

	showApproved(vehicle: Vehicle) {
		if (vehicle['approved'] !== 0) {
			this.refillsHandlerService.refills_list_props.filter_column = 'refills_expanded.vhc_plate';
			this.refillsHandlerService.refills_list_props.filter_value = vehicle.plate.toString();
			this.refillsHandlerService.refills_list_props.status_attivo = 3;
			this.refillsHandlerService.changeFilterName('Targa');
			this.refillsHandlerService.reloadRefillsListAndCount();
			this.router.navigate(['./dashboard/refills']);
		}
	}

	showTravel(vehicle: Vehicle) {
		if (vehicle['travels'] !== 0) {
			this.travelsHandlerService.travels_list_props.filter_column = 'travels_expanded.vhc_plate';
			this.travelsHandlerService.travels_list_props.filter_value = vehicle.plate.toString();
			this.travelsHandlerService.reloadTravelsListAndCount();
			this.router.navigate(['./dashboard/travels']);
		}
	}

	showTravelFromChart($event) {
		const vehicles = this.vehicles[this.selected_park.id];
		this.showTravel(vehicles.find(s => s.plate === $event.name));
	}

	showRefills($event) {
		if ($event.name && $event.series) {
			const vehicles = this.vehicles[this.selected_park.id];
			const v = vehicles.find(s => s.plate === $event.series);
			if ($event.name === 'In attesa') {
				this.showPending(v);
			} else if ($event.name === 'Rifiutati') {
				this.showRefused(v);
			} else {
				this.showApproved(v);
			}
		}
	}

	assignVehicle(vehicle: Vehicle) {
		this.assignUserToCarDialog.showDialog(vehicle);
	}

	vehicleAssigned() {
		this.reloadParks();
		this.statusChanged.next(undefined);
	}

	createFermo($event) {
		this.createFermoTecnicoDialog.showDialog($event);
	}
}
